import View from "../../../Nav/Js/views/StrateMacView";
import components from "./components.js";
components.define("js-StrateMacView", View);